import request from '@/router/axios'

const pre_fix = "/dotadmin/dotadmin/file/"

export function listFile(query) {
  return request({
    url: pre_fix+'list/'+query.orderId,
    method: 'get',
    params: query
  })
}

export function newListFile(query) {
  return request({
    url: pre_fix+'newList/'+query.orderId,
    method: 'get',
    params: query
  })
}

export function analysisFile(query) {
  return request({
    url: pre_fix+'analysisFile/'+query.orderId,
    method: 'get',
    params: query
  })
}

export function smartCheckFile(query) {
  return request({
    url: pre_fix + 'smartCheck/' + query.orderId,
    method: 'get',
    params: query,
  });
}

// 判断批量下载按钮点亮与否
export function batchDownloadCheck(query) {
  return request({
    url: '/file/batchDownload/check',
    method: 'get',
    params: query
  })
}

// 批量下载
export function execute(obj) {
  return request({
    url: '/file/batchDownload/execute',
    method: 'post',
    data: obj
  })
}

// 获取下载URL
export function zipUrl(query) {
  return request({
    url: '/file/batchDownload/url',
    method: 'get',
    params: query
  })
}

// 获取批量下载进度
export function zipProcess(query) {
  return request({
    url: '/file/batchDownload/process',
    method: 'get',
    params: query
  })
}

// 删除zip包
export function zipDelete(query) {
  return request({
    url: '/file/batchDownload/clear',
    method: 'post',
    data: query
  })
}

// 获取zip命名
export function zipName(query) {
  return request({
    url: '/file/batchDownload/zipName',
    method: 'post',
    data: query
  })
}


